import { render, staticRenderFns } from "./RetailPurchaseOfMedicine.vue?vue&type=template&id=1148ac13&scoped=true"
import script from "./RetailPurchaseOfMedicine.vue?vue&type=script&lang=js"
export * from "./RetailPurchaseOfMedicine.vue?vue&type=script&lang=js"
import style0 from "./RetailPurchaseOfMedicine.vue?vue&type=style&index=0&id=1148ac13&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1148ac13",
  null
  
)

export default component.exports